<template>
  <div class="attr-row">
    <div class="attr-label" :style="attrLabelStyle">{{ label }}
      <slot name="hint"/>
    </div>
    <div :style="[attrValueStyle, valStyle]">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TumengAttrRow',
  props: {
    label: {
      type: String,
      default: ''
    },
    labelWidth: {
      type: Number,
      default: 280
    },
    height: {
      type: Number,
      default: 28
    },
    valStyle: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    attrLabelStyle() {
      return {
        float: 'left',
        width: this.labelWidth + 'px',
        height: this.height + 'px',
        lineHeight: this.height + 'px',
        color: 'black'
      }
    },
    attrValueStyle() {
      return {
        float: 'left',
        width: '100%'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.attr-row {
  margin-bottom: 8px;
  color: #2c3e50;
  text-align: left;
  font-size: 12px;
  &:after {
    content: "";
    display: block;
    clear: both;
  }
}
</style>
